// @ts-ignore
export const isFirefox = typeof InstallTrigger !== 'undefined'; // https://stackoverflow.com/a/9851769
